import { useToasts } from "@certn/cascadia";
import {
  DangerButton,
  Divider,
  Layout,
  Text,
  Container,
  Link,
} from "@certn/cascadia-react";
import { useAPIRequest, APIError } from "@certn/legacy-api";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useStyles } from "./styles";
import { AppFooter } from "../../components/AppFooter";
import { AppHeader } from "../../components/AppHeader";

export function DeclineRequest() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const teamName = searchParams.get("team_name");
  const { applicantId } = useParams();
  const styles = useStyles();
  const request = useAPIRequest();
  const { show } = useToasts();
  const navigate = useNavigate();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const handleDeclineRequest = async () => {
    try {
      await request(
        `/internal/people/applicant/${applicantId}/decline-request/`,
        {
          method: "POST",
        }
      );
      navigate(`/request-declined?team_name=${teamName}`);
    } catch (e: unknown) {
      if (e instanceof APIError) {
        if (e.detail === "id_verification_started") {
          setShowErrorMessage(true);
        } else {
          show({
            title: t("Something went wrong, try again"),
            type: "error",
          });
        }
      }
    }
  };
  return (
    <Layout
      layout="auth"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
    >
      <Container>
        <div className={styles.container}>
          <div>
            <Text as="h2" style="form/page-title">
              <Trans>Decline request</Trans>
            </Text>
          </div>
          {showErrorMessage ? (
            <div>
              <Text style="form/body-primary" color="text-warning">
                <Trans>
                  You are unable to decline this request as you have started the
                  Identity Verification session. Please contact support@certn.co
                </Trans>
              </Text>
            </div>
          ) : (
            <>
              <div>
                <Text style="form/body-primary" color="text-weak">
                  <Trans>
                    If you've decided not to proceed with the background check
                    for {{ teamName }} select the “Decline request“ button
                    below. Once confirmed, {{ teamName }} will be notified and
                    the check will be cancelled.
                  </Trans>
                </Text>
              </div>
              <div>
                <Text style="form/body-primary" color="text-weak">
                  <Trans>Please note this action cannot be undone.</Trans>
                </Text>
              </div>
              <DangerButton
                testID="decline-request-button"
                size="large"
                onPress={handleDeclineRequest}
                fullWidth
              >
                <Trans>Decline request</Trans>
              </DangerButton>
              <Divider />
              <div>
                <Text style="form/body-primary" color="text-weak">
                  <Trans>
                    If you do not want to decline the request,{" "}
                    <Link
                      testID="decline-request-back-link"
                      href="/"
                      textStyle="global/body-secondary"
                      textColor="text-weak"
                    >
                      click here
                    </Link>{" "}
                    to complete the background check.
                  </Trans>
                </Text>
              </div>
            </>
          )}
        </div>
      </Container>
    </Layout>
  );
}
